import React from 'react';
import ErrorManager from '../classes/ErrorManager';
import Translation from '../classes/Translation';
import Helper from '../classes/Helper';

export default class ErrorAlert extends React.Component {
    componentDidMount() {
        if(Helper.isFulledit() || Helper.isEmployee() || Helper.isTestmode()) {
            const errorElement = window.document.getElementById('error-alert');
            if (ErrorManager.hasErrors() && errorElement) {
                const errors = ErrorManager.getErrors();
                errorElement.innerHTML = `
                <div>
                    <span>` + Translation.getTranslation('error_title') +`:</span>
                    <ul>
                    ${errors.map(error => `<li>${error}</li>`).join('')}
                    </ul>
                </div>
                `;
            }
        }
    }
  
    componentWillUnmount() {
      const errorElement = window.document.getElementById('error-alert');
      if (errorElement) {
        errorElement.innerHTML = '';
      }
    }
  
    render() {
      return null;
    }
  }